import AppRoutes from "./routes/AppRoutes";
import { AuthProvider } from "./context/AuthContext";
import GlobalStyles from "./styles/GlobalStyles";
import { BrowserRouter as Router } from "react-router-dom";
import { LoadingProvider } from "./context/LoadingContext"; // ✅ Import global loading state
import { CookieConsentProvider, useCookieConsent } from "./context/CookieConsentContext"; // ✅ Import Cookie Consent Context
import CookieConsent from "./components/CookieConsent"; // Import CookieConsent component
function App() {
  return (
    <CookieConsentProvider>
      <LoadingProvider>
        <Router>
          <AuthProvider>
            <GlobalStyles />
            <AppRoutes />
            <GlobalCookieConsent />
          </AuthProvider>
        </Router>
      </LoadingProvider>
    </CookieConsentProvider>
  );
}

const GlobalCookieConsent = () => {
  const { cookieAccepted } = useCookieConsent();

  // Only show CookieConsent if cookies are not accepted yet
  if (cookieAccepted) return null; // Hide the cookie consent if accepted

  return <CookieConsent />;
};
export default App;
